;delta.reportWizard = function () {
    
    const ReportType = {
        BalanceSheet: 0,
        IncomeStatement:1,
        CashFlow: 2,
        RollingForecast: 3,
        NetAssetRollForward: 4,
        FunctionalExpense: 5 
    };

    var

    _current_step = 1,  
    _num_steps,
    _done = false

    
    //
    // called from page that opens the wizard popup
    //
    init = function() {
        if ($('.layout-report-list').length > 0) {
            setupReportWizard();
        }
    },


    setupReportWizard = function () {
        $(document).on('shown.bs.modal', '.modal-newreport-wizard', function () {
            var $popup = $(this);

            //reset to starting values
            _current_step = 1,  
            _done = false;

            _$wrapper.find('#lnkAddReport .icon-plus').show();
            _$wrapper.find('#lnkAddReport .icon-spinner').hide();

            $('#container-steps').show();
            $(".report-type-step").addClass("show active");

            //default values
            $('#PriorVariance2Type, #DepartmentVariance2Type, #ClassVariance2Type').val("VariancePercentAB");

            wizardButtons();
            wizardReportTitle();
            wizardReportType();
            wizardCurrent();
            wizardPrior();
            wizardPriorVariance();
            wizardBudget();
            wizardDimensionType();
            wizardColumnSettings();

            //js module that handles enabling/disabling for IS Dimension Columns
            delta.reportDimensionColumns.init($popup);

            showStep(1);
        });
    },

    wizardButtons = function () {
        const $prevBtn = $(".modal-newreport-wizard button[data-btn-index='0']");
        const $nextBtn = $(".modal-newreport-wizard button[data-btn-index='1']");
        const $finishBtn = $(".modal-newreport-wizard button[data-btn-index='3']");
        const $wizardNote = $('#wizard-note');

        $($prevBtn).prop("disabled", true);
        $($finishBtn).prop("disabled", true);


        $($prevBtn).on("click", function () {
            validateStep('prev');
            if (_current_step > 1) {
                showStep(+_current_step - 1);
                if (_current_step === 1) {
                    $wizardNote.hide();
                }

            }
        });

        $($nextBtn).on("click", function () {
            const incomplete = validateStep('next');
            if (!incomplete && _current_step < _num_steps) {
                showStep(_current_step + 1);
            }
            if (_current_step === _num_steps) {
                showWizardSummary();
            }
            if (_current_step > 1) {
                $wizardNote.show();
            }

        });
    },


    wizardReportTitle = function () {
        $("#ReportTitle").on("input paste cut change keyup", function () {
            const $finishBtn = $(".modal-newreport-wizard button[data-btn-index='3']");
            if ($('#ReportTitle').val().trim() === "") {
                $($finishBtn).prop("disabled", true);
            } else if (_done) {
                $($finishBtn).prop("disabled", false);
            }
        });
    },

    
    wizardReportType = function () {
        $('#ReportType').on('change', function () {
            var reportType = parseInt($(this).val());
            const $period = $('#PriorDateRange , #CurrentDateRange');
            const $isPeriod = $("#HiddenISPeriod");
            const $bsPeriod = $("#HiddenBSPeriod");
            const $cfPeriod = $("#HiddenCFPeriod");
            const $priorVarianceRow = $('.prior-variance-row');

            $('.step-available').removeClass('step-available');

            $priorVarianceRow.show(); // Variance for 'Prior' is hidden on 'Cash Flow'. Let's make it visible, and we hide it when cash flow is selected.
            $period.empty();

            $('.wizard-step').closest('td').hide(); // initially hide all steps, re-enable below

            switch (reportType) {
                case ReportType.BalanceSheet:
                    //Add the right options to the dd base on repot type
                    $bsPeriod.find("option").clone().appendTo($period);
                    $('#CurrentDateRange').val('15');
                    $('#PriorDateRange').val('16');
                    $('#autoPopup_1').removeClass('modal-lg');
                    $('.wizard-step.bs-step').closest('td').show();
                    $('.bs-step').addClass('step-available');
                    break
                case ReportType.IncomeStatement:
                    //Add the right options to the dd base on repot type
                    $isPeriod.find("option").clone().appendTo($period);
                    $('#CurrentDateRange').val('8');
                    $('#PriorDateRange').val('11');
                    $('.wizard-step.is-step').closest('td').show();
                    $('.is-step').addClass('step-available');
                    $('.bs-step').addClass('step-available');
                    $('.dimension-columns-wrapper .dimension-filter').hide();
                    $('.dimension-columns-wrapper .dimension-filter-none').show();
                    $('.dimension-columns-wrapper nav').hide();
                    delta.reportDimensionColumns.reset();
                    break
                case ReportType.CashFlow:
                    $cfPeriod.find("option").clone().appendTo($period);
                    $('#CurrentDateRange').val('21');
                    $('#PriorDateRange').val('24');
                    $('.wizard-step.cf-step').closest('td').show();
                    $('.cf-step').addClass('step-available');
                    $('#PriorVariance1 ,#PriorVariance2').prop("checked", false) // Clear previous selected choices
                    $priorVarianceRow.hide();
                    break        
                case ReportType.RollingForecast:
                    $('.wizard-step.rf-step').closest('td').show();
                    $('.rf-step').addClass('step-available');
                    break
                case ReportType.NetAssetRollForward:
                    $isPeriod.find("option").clone().appendTo($period);
                    $('#PriorDateRange, #ClassPriorDateRange, #DepartmentPriorDateRange, #ProjectPriorDateRange').val('11');
                    $('#CurrentDateRange').val('8');
                    $('.wizard-step.na-step').closest('td').show();
                    $('.na-step').addClass('step-available');
                    break;
                case ReportType.FunctionalExpense:
                    $isPeriod.find("option").clone().appendTo($period);
                    $('#PriorDateRange, #ClassPriorDateRange, #DepartmentPriorDateRange, #ProjectPriorDateRange').val('11');
                    $('#CurrentDateRange').val('8');
                    $('.wizard-step.fe-step').closest('td').show();
                    $('.fe-step').addClass('step-available');

                    $priorVarianceRow.hide();
                    break;
            }

            _num_steps = $('.container-steps .step-available').length;

            // if (_num_steps >= 5) $('#autoPopup_0').addClass('modal-lg');
            // else $('#autoPopup_0').removeClass('modal-lg');

            //We assign consecutive IDs to all available tabs, which are then used for navigation purposes.
            $('.wizard-step').removeAttr('id');
            const visibleSteps = document.querySelectorAll('.container-steps .step-available');
            Array.from(visibleSteps).map((step, index) => {
                step.id = `StepWizard${index + 1}`;
            });

            $('.tab-pane:not(.tab-pane-dimension)').removeAttr('id');
            const visibleTabSteps = document.querySelectorAll('.tab-content .step-available');
            Array.from(visibleTabSteps).map((step, index) => {
                step.id = `StepTab${index + 1}`;
            });

            
            //remove complete status from other steps
            $('.modal-newreport-wizard .tbl-steps td:visible').each(function(idx) {        
                if (idx > 0) {
                    var $td = $(this); 
                    var $cir = $td.find('.wizard-step-circle');

                    $td.removeClass('td-completed');
                    $cir.removeClass('wizard-step-completed');
                }
            });

            // disablefinish button
            $(".modal-newreport-wizard button[data-btn-index='3']")
                .removeClass('btn-success')
                .addClass('btn-light')
                .prop('disabled', true);

            //redraw steps, my have some tds that are now visible
            showStep(_current_step);


        }).trigger('change');
    },


    wizardCurrent = function () {
        $("#Current").on("change", function () {
            const $currentPeriod = $(".current-children");
            const $currentChildrenCheckbox = $(".current-children-checkbox");

            if ($(this).is(":checked")) {
                $currentPeriod.prop("disabled", false);
            } else {
                $currentPeriod.prop("disabled", true);
                $currentChildrenCheckbox.prop("checked", false);
            }
            $("#Prior").trigger("change");
        });
    },


    wizardPrior = function () {
        $("#Prior").on("change", function () {
            const $currentPeriod = $('#Current');
            const $priorPeriod = $(".prior-children");
            const $priorSectionHeading = $('#PriorSectionHeading');
            const $variantCheckbox = $('#PriorVariance1, #PriorVariance2');

            if ($(this).is(":checked")) {
                $priorPeriod.prop("disabled", false);
                $priorSectionHeading.prop("disabled", false);
                $("#PriorVariance1, #PriorVariance2")
                    .prop("disabled", false)
                    .trigger("change");
            } else {
                $priorPeriod.prop("disabled", true);
                $priorSectionHeading.prop("disabled", true).prop("checked", false);
                $variantCheckbox.prop("disabled", true)
                    .prop("checked", false)
                    .trigger("change");
            }


            if ($currentPeriod.is(":checked") === false) {
                $priorSectionHeading.prop("disabled", true).prop("checked", false);
                $variantCheckbox.prop("disabled", true)
                    .prop("checked", false)
                    .trigger("change");
            }

            $("#Budget").trigger("change");

        }).trigger('change');
    },


    wizardPriorVariance = function () {
        $("#PriorVariance1").on("change", function () {
            const $priorVariance1Type = $("#PriorVariance1Type");
            if ($(this).is(":checked")) {
                $priorVariance1Type.prop("disabled", false);
            } else {
                $priorVariance1Type.prop("disabled", true);
            }
        }).trigger('change');

        $("#PriorVariance2").on("change", function () {
            const $priorVariance1Type = $("#PriorVariance2Type");

            if ($(this).is(":checked")) {
                $priorVariance1Type.prop("disabled", false);
            } else {
                $priorVariance1Type.prop("disabled", true);
            }
        }).trigger('change');
    },


    wizardBudget = function () {
        $("#Budget").on("change", function () {
            const $prior = $('#Prior').prop('checked');
            const $current = $('#Current').prop('checked');

            if ($(this).is(":checked")) {
                $("#BudgetVariance").prop("disabled", false).trigger("change");
                $("#BudgetID").prop("disabled", false);
            } else {
                $("#BudgetID").prop("disabled", true);
                $("#BudgetVariance, #BudgetSectionHeading").prop("disabled", true)
                    .prop("checked", false)
                    .trigger("change");
            }

            if (!$prior && !$current) {
                $("#BudgetVariance").prop("disabled", true)
                    .prop("checked", false)
                    .trigger("change");
            }

        }).trigger('change');

        $("#BudgetVariance").on("change", function () {
            if ($(this).is(":checked")) {
                $("#BudgetVarianceCompareColumn , #BudgetVarianceType , #BudgetSectionHeading").prop("disabled", false);
            } else {
                $("#BudgetVarianceCompareColumn , #BudgetVarianceType , #BudgetSectionHeading").prop("disabled", true);
                $("#BudgetSectionHeading").prop("checked", false);
            }
        }).trigger('change');
    },

    
    //
    // For IS reports, when dimension changes show/hide the appropriate check list in Dimension Columns
    //
    wizardDimensionType = function() {
        $('#DimensionFEIS').on('change', function() {
            var reportType = parseInt($('#ReportType').val());
            var $cbo = $(this);
            var dimensionType = $cbo.val().toLowerCase();

            if (reportType == ReportType.IncomeStatement) {            
                //hide all dimension columns
                $('.dimension-columns-wrapper .dimension-filter').hide();

                //show the currently selected dimensions
                $('.dimension-columns-wrapper .dimension-filter-' + dimensionType).show();

                //show/hide the tabs
                if (dimensionType == 'None') {
                    $('.dimension-columns-wrapper nav').hide();
                } else {
                    $('.dimension-columns-wrapper nav').show();
                }



                //reset the controls to their initial state
                delta.reportDimensionColumns.reset();

                //update the dimension name in the include section headers checkbox
                var dimensionName = $cbo.find('option:selected').text();
                delta.reportDimensionColumns.updateIncludeHeadersText(dimensionName);
            }

        }).trigger('change');
    },


    wizardColumnSettings = function () {
        updateRFSettingsToggle();

        var $chkAnnualBudget = $('#ColumnSettings_HasAnnualBudgetColumn');
        var $chkVariance = $('#ColumnSettings_HasVarianceColumn');
        var $chkISAcctMap = $('#UseISAcctMapping');
        var $chkCFAcctMap = $('#UseCFAcctMapping');

        var $checks = $chkAnnualBudget.add($chkVariance).add($chkISAcctMap).add($chkCFAcctMap);
        $checks.on('click', function () {
            updateRFSettingsToggle();
        });
        

        // check final validity if dropdowns changed after Done step
        var $annualBudget = $("#ColumnSettings_AnnualBudgetID");
        var $cfMapID = $("#CFAcctMapID");
        var $isMapID = $("#ISAcctMapID");
        var $elements = $checks.add($annualBudget).add($cfMapID).add($isMapID);
        $elements.on('change', function () {
            const $finishBtn = $(".modal-newreport-wizard button[data-btn-index='3']");
            var done = !$finishBtn.hasClass("btn-light");
            if (done) {
                if (($chkAnnualBudget.is(':checked') && $annualBudget.val() == '') || ($chkISAcctMap.is(':checked') && $isMapID.val() == '') || ($chkCFAcctMap.is(':checked') && $cfMapID.val() == '')) {
                    $finishBtn.prop('disabled', true)
                }
                else {
                    $finishBtn.prop('disabled', false)
                }
            }
        })
    },


    validateStep = function (action) {
        $('.required-label').remove();
        let incomplete = false;
        var reportType = parseInt($("#ReportType").val());
        
        if (_current_step === 2 && $('#ReportTitle').val().trim() === "") {
            if (action === 'next') {
                $('#ReportTitle').after('<label class="required-label text-danger mt-1">Report title is required</label>');
                $('#ReportTitle').trigger('focus');
            }
            incomplete = true;
            $("#StepWizard2 .wizard-step-circle").removeClass('wizard-step-completed');
        }

        // rolling forecast column settings validation
        else if (reportType == ReportType.RollingForecast && _current_step === 3) {
            if (action === 'next') {
                if ($('#ColumnSettings_ForecastBudgetID').val() == "") {
                    $('#ColumnSettings_ForecastBudgetID').after('<label class="required-label text-danger mt-1">Forecast budget is required</label>');
                    $('#ColumnSettings_ForecastBudgetID').trigger('focus');
                    incomplete = true;
                }
                if ($('#ColumnSettings_HasAnnualBudgetColumn').prop('checked') && $('#ColumnSettings_AnnualBudgetID').val() == "") {
                    $('#ColumnSettings_AnnualBudgetID').after('<div class="w-100 pr-0 required-label text-danger mt-1">Required if Annual Budget checked</div>');
                    $('#ColumnSettings_AnnualBudgetID').trigger('focus');
                    incomplete = true;
                }
                if ($('#ColumnSettings_ActualHeaderText').val() == "") {
                    $('#ColumnSettings_ActualHeaderText').after('<div class="w-100 pr-0 required-label text-danger mt-1">Actual Header Text required</div>');
                    $('#ColumnSettings_ActualHeaderText').trigger('focus');
                    incomplete = true;
                }
                if ($('#ColumnSettings_ForecastHeaderText').val() == "") {
                    $('#ColumnSettings_ForecastHeaderText').after('<div class="w-100 pr-0 required-label text-danger mt-1">Forecast Header Text required</div>');
                    $('#ColumnSettings_ForecastHeaderText').trigger('focus');
                    incomplete = true;
                }
            }
            if (incomplete == true) {
                $("#StepWizard3 .wizard-step-circle").removeClass('wizard-step-completed');
            }
        }
        // rolling forecast account mapping validation
        else if (reportType == ReportType.RollingForecast && _current_step === 4) {
            if (action === 'next') {
                if ($('#UseISAcctMapping').prop('checked') && $('#ISAcctMapID').val() == "") {
                    $('#ISAcctMapID').after('<div class="w-100 pr-0 required-label text-danger mt-1">Required if Income Statement mapping is checked</div>');
                    $('#ISAcctMapID').trigger('focus');
                    incomplete = true;
                }
                if ($('#UseCFAcctMapping').prop('checked') && $('#CFAcctMapID').val() == "") {
                    $('#CFAcctMapID').after('<div class="w-100 pr-0 required-label text-danger mt-1">Required if Cash Flow mapping is checked</div>');
                    $('#CFAcctMapID').trigger('focus');
                    incomplete = true;
                }
            }
            if (incomplete == true) {
                $("#StepWizard4 .wizard-step-circle").removeClass('wizard-step-completed');
            }
        }

        // validate dimension selection for FE and NARF reports
        else if ((reportType == ReportType.FunctionalExpense || reportType == ReportType.NetAssetRollForward) && _current_step == 3) {
            var ddl = reportType == ReportType.FunctionalExpense ? $('#DimensionFEIS') : $('#DimensionNA');
            if (action === 'next' && ddl.val() === "None") {
                ddl.addClass('is-invalid');
                if ($('#DimensionInvalidFeedback').length == 0)
                    ddl.after(`<div id="DimensionInvalidFeedback" class="invalid-feedback">Dimension is required</div>`);
                ddl.trigger('focus');
                incomplete = true;
            }
            else {
                ddl.removeClass('is-invalid');
                $('#DimensionInvalidFeedback').remove();
            }
        }

        // FE expense mapping validation
        else if (reportType == ReportType.FunctionalExpense && _current_step == 4) { // FE Import step
            if (action === 'next') {
                if ($('#UseFEExpenseMapping').prop('checked') && $('#FEExpenseMapID').val() == "") {
                    $('#FEExpenseMapID').after('<div class="w-100 pr-0 required-label text-danger mt-1">Required if Import Expenses is checked</div>');
                    $('#FEExpenseMapID').trigger('focus');
                    incomplete = true;
                }
            }
            if (incomplete == true) {
                $("#StepWizard4 .wizard-step-circle").removeClass('wizard-step-completed');
            }
        }
        else if (_current_step === 7 && reportType == ReportType.IncomeStatement) {
            if (!delta.reportDimensionColumns.validate()) {
                $('#Budget .wizard-step-circle').removeClass('wizard-step-completed');
                incomplete = true;
            }
        }

        return incomplete;
    },

    showStep = function (step) {
        const $prevBtn = $(".modal-newreport-wizard button[data-btn-index='0']");
        const $nextBtn = $(".modal-newreport-wizard button[data-btn-index='1']");
        const $finishBtn = $(".modal-newreport-wizard button[data-btn-index='3']");
        const $currentStepWizard = $("#StepWizard" + step);
        const $currentStepCircle = $currentStepWizard.find('.wizard-step-circle');

        $(".tab-pane:not(.tab-pane-dimension), .wizard-step-circle").removeClass("show active wizard-step-active");

        $("#StepTab" + step).addClass("show active");
        $currentStepWizard.addClass("show active");

        if (step > 1) {
            $("#StepWizard" + (+step - 1) + ' .wizard-step-circle').addClass('wizard-step-completed');
        }

        if (step == 2) {
            $("#ReportTitle").trigger('focus');
        }

        $prevBtn.prop("disabled", step === 1);
        $nextBtn.prop("disabled", step === _num_steps);

        if (_num_steps === step) {
            $finishBtn.addClass("btn-success").removeClass("btn-light").prop("disabled", false);
            _done = true;
        }

        if (step === _num_steps) $currentStepCircle.addClass('wizard-step-completed wizard-step-active');
        else $currentStepCircle.addClass('wizard-step-active');

        $('.modal-newreport-wizard .tbl-steps td:visible').each(function(idx) {        
            var $td = $(this);
            var $cir = $td.find('.wizard-step-circle');

            if ($cir.hasClass('wizard-step-completed')) $td.addClass('td-completed');
            else $td.removeClass('td-completed');

            if ($cir.hasClass('wizard-step-active')) $td.addClass('td-active');
            else $td.removeClass('td-active');

            $cir.html(idx+1);
        });

        _current_step = step;
    },


    showWizardSummary = function () {
        const reportType = parseInt($('#ReportType').val());
        let newItem;
        $('.wizard-summary').empty();
        $('.acct-map-summary').empty();
        $('#acct-mapping').hide();


        if ($('#Current').prop('checked') && (reportType == ReportType.BalanceSheet || reportType == ReportType.CashFlow || reportType == ReportType.IncomeStatement)) {
            newItem = '<li class= "li-current"> Actual (Current), ' + $('#CurrentDateRange option:selected').text() + '</li>'
            $('.wizard-summary').append(newItem);

            if ($('#CurrentSectionHeading').prop('checked')) {
                $('.li-current').append('<ul><li>Include a section header for Actuals</li></ul>');
            }
        }

        if ($('#Prior').prop('checked') && (reportType == ReportType.BalanceSheet || reportType == ReportType.CashFlow || reportType == ReportType.IncomeStatement)) {
            newItem = '<li class = "li-prior"> Actual (Prior), ' + $('#PriorDateRange option:selected').text() + '</li>';
            $('.wizard-summary').append(newItem);

            const $priorVariance1 = $('#PriorVariance1').prop('checked');
            const $priorVariance2 = $('#PriorVariance2').prop('checked');
            const $priorSectionHeading = $('#PriorSectionHeading').prop('checked');

            if ($priorVariance1 || $priorVariance2 || $priorSectionHeading) {
                let varianceMessage = '<ul><li class = "li-variance-prior">Type of variance calculation:</li><ul>';
                let varianceMessageItems = "<ul>";
                $('.li-prior').append(varianceMessage);

                if ($priorVariance1) {
                    varianceMessageItems += '<li>' + $('#PriorVariance1Type option:selected').text() + '</li>';
                }
                if ($priorVariance2) {
                    varianceMessageItems += '<li>' + $('#PriorVariance2Type option:selected').text() + '</li>';
                }
                $('.li-variance-prior').append(varianceMessageItems + '</ul>');

                if ($priorSectionHeading) {
                    $('.li-prior').append('<ul><li>Include a section header for Prior Comparative</li></ul>');
                }
            }

        }

        // Income Statement Dimensions
        if (reportType == ReportType.IncomeStatement) {
            //dimension dropdown
            var $opt = $('#DimensionFEIS option:selected');
            if ($opt.attr('value') != 'None') {
                $('.wizard-summary').append(`<li>Columns by Dimension: ${$opt.text()}</li>`);
            }

            //the rest is done in the report-dimension-columns.js, we alredy have references there
            //for all the elements we need
            var dimSummary = delta.reportDimensionColumns.summary();
            if (dimSummary) {
                $('.wizard-summary').append(dimSummary);
            }
        }

        // columns for Rolling Forecast
        else if (reportType == ReportType.RollingForecast) {
            // actuals
            newItem = `<li class="li-actuals"> Actuals ${!$('#ColumnSettings_ActualsByMonth').prop('checked') ? " (as single YTD column)" : ""}</li>`;
            $('.wizard-summary').append(newItem);
            if ($('#ColumnSettings_UseSectionHeaders').prop('checked')) {
                $('.li-actuals').append('<ul><li>Include a section header for Actuals</li></ul>');
            }

            // forecasts
            newItem = `<li class="li-forecasts"> Forecasts, ${$('#ColumnSettings_ForecastBudgetID option:selected').text()}</li>`;
            $('.wizard-summary').append(newItem);
            if ($('#ColumnSettings_UseSectionHeaders').prop('checked')) {
                $('.li-forecasts').append('<ul><li>Include a section header for Forecasts</li></ul>');
            }

            // total column
            newItem = '<li> Total (Actuals + Forecasts)</li>';
            $('.wizard-summary').append(newItem);

            // annual budget column
            if ($('#ColumnSettings_HasAnnualBudgetColumn').prop('checked')) {
                newItem = `<li class="annual-budget"> Budget, ${$('#ColumnSettings_AnnualBudgetID option:selected').text()}</li>`;
                $('.wizard-summary').append(newItem);

                // variance column
                if ($('#ColumnSettings_HasVarianceColumn').prop('checked')) {
                    newItem = `<li class="rf-variance"> Variance, ${$('#ColumnSettings_VarianceType option:selected').text()}</li>`;
                    $('.wizard-summary').append(newItem);
                }
            }

            if ($('#UseISAcctMapping').prop('checked') || $('#UseCFAcctMapping').prop('checked')) {
                // account mapping IS
                if ($('#UseISAcctMapping').prop('checked')) {
                    newItem = `<li> Revenue/Expense accounts will be mapped from the ${$('#ISAcctMapID option:selected').text()} report.</li>`;
                    $('.acct-map-summary').append(newItem);
                }
                // account mapping CF
                if ($('#UseCFAcctMapping').prop('checked')) {
                    newItem = `<li> Cash adjustment accounts will be mapped from the ${$('#CFAcctMapID option:selected').text()} report.</li>`;
                    $('.acct-map-summary').append(newItem);
                }
                $('#acct-mapping').show();
            }
        }

        // Net Asset Roll-Forward options
        else if (reportType == ReportType.NetAssetRollForward) { 
            // Show dimension information
            let selectedDimension = $('#DimensionNA option:selected').text();
            $('.wizard-summary').append(`<li>Columns by Dimension: ${selectedDimension}</li>`);

            let useReceivablesCol = $('#IncludeReceivableColumns').is(':checked');
            let txtReceivablesCol = $('label[for="IncludeReceivableColumns"]').text();
            $('.wizard-summary').append(`<li>${txtReceivablesCol}: ${(useReceivablesCol ? 'YES' : 'NO')}</li>`);

            let useNotesCol = $('#IncludeNotesInDataEntry').val();
            let txtNotesCol = $('label[for="IncludeNotesInDataEntry"]').text();
            $('.wizard-summary').append(`<li>${txtNotesCol}: ${(useNotesCol ? 'YES' : 'NO')}</li>`);
        }

        // Functional Expense options
        else if (reportType == ReportType.FunctionalExpense) { 
            // Show dimension information
            var selectedDimension = $('#DimensionFEIS option:selected').text();
            $('.wizard-summary').append(`<li>Columns by Dimension: ${selectedDimension}</li>`);

            // Show expense import information
            $('.acct-map-summary').append(`<li>Import from: <i>${ ($('#FEExpenseMapID option:selected').text()) }</i></li>`);
            $('#acct-mapping').show();

        }
    },



    updateRFSettingsToggle = function () {
        var budgetChecked = $('#ColumnSettings_HasAnnualBudgetColumn').prop('checked');
        var $annualBudgetDropdown = $('#ColumnSettings_AnnualBudgetID');
        var $chkVariance = $('#ColumnSettings_HasVarianceColumn');
        var varianceChecked = $chkVariance.prop('checked');
        var $varianceDropdown = $('#ColumnSettings_VarianceType');
        var isAcctMapChecked = $('#UseISAcctMapping').prop('checked');
        var $isAcctMapDropdown = $('#ISAcctMapID');
        var cfAcctMapChecked = $('#UseCFAcctMapping').prop('checked');
        var $cfAcctMapDropdown = $('#CFAcctMapID');


        // set variance check option based on total and budget checked
        if (!budgetChecked) {
            $chkVariance.prop('checked', false);
            varianceChecked = false;
            // reset budget select to default
            $annualBudgetDropdown.val($annualBudgetDropdown.find('option:first').val());
        }

        // reset to defaults if not checked
        if (!isAcctMapChecked) {
            $isAcctMapDropdown.val($isAcctMapDropdown.find('option:first').val());
        }
        if (!cfAcctMapChecked) {
            $cfAcctMapDropdown.val($cfAcctMapDropdown.find('option:first').val());
        }

        // set enable/disable options
        $annualBudgetDropdown.prop('disabled', !budgetChecked);
        $varianceDropdown.prop('disabled', !varianceChecked);
        $chkVariance.prop('disabled', !budgetChecked);
        $isAcctMapDropdown.prop('disabled', !isAcctMapChecked);
        $cfAcctMapDropdown.prop('disabled', !cfAcctMapChecked);
    },


    //
    // save the wizard values
    //
    save = function($popup) {
        $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 fa-spinner"></i>');
        var formData = new FormData();

        // Get all the dimension filters and add it to the formData
        $popup.find('.modal-body .step-available input[name="DimensionColumns.DimensionBuilder.Filters"]:checked').each(function() {
            formData.append($(this).attr('name'), $(this).val());
        });

        $popup.find('.modal-body').find('input[type="hidden"], .step-available input[type="text"], .step-available input[type="checkbox"][name!="DimensionColumns.DimensionBuilder.Filters"], .step-available input[type="radio"], .step-available select').each(function () {
            var $elem = $(this);
            var name = $elem.attr('name');

            // For checkboxes, set the value to true if checked, otherwise false
            var value = $elem.is(':checkbox, :radio') ? $elem.is(':checked') : $elem.val();

            formData.append(name, value);
        });

        delta.ajax.postFormData(
            '/reportlist/reportwizard',
            formData,
            function (result) {
                if (!result.ok) {
                    $('.modal-newreport-wizard  .modal-footer .fa-spinner').remove();
                    $popup.find('.modal-body').html(result.html);
                    delta.popup.enableButtons($popup);
                }
                else window.location = result.url; //redirect
            }
        );

    },

    dummy = function () { };

    $(document).ready(init);    

    //return methods
    return {
        save: save
    };

}();